module.exports = __webpack_public_path__ + "static/media/jEUR.22df9aff.png";